import React from 'react';
import PropTypes from 'prop-types';

import {Pill} from 'views/components';
import {translate} from 'views/module';

const CaregiverStatusView = (props) => {
  const {
    caregiverData,
    setIsEditing,
  } = props;

  const status = caregiverData.status;

  const title = translate(`caregiver.Status.${status}.Title`);

  return (
    <Pill
      label={`● ${title}`}
      variant='warning'
      component='button'
      type='button'
      onClick={() => setIsEditing(true)}
      sx={{cursor: 'pointer'}}
    />
  );
};

CaregiverStatusView.propTypes = {
  caregiverData: PropTypes.object.isRequired,
  setIsEditing: PropTypes.func.isRequired,
};

export default React.memo(CaregiverStatusView);
